<script>
// 头像组件：显示图片头像，没有图片时，显示姓名的第一个字（底部颜色随机），都没有时显示默认图
export default {
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    // 使用资源文件中的链接作为默认图片
    defaultImg: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'sm', // xxs xs sm md lg xl
    },
    rounded: {
      type: Boolean,
      default: false
    },
    roundedCircle: {
      type: Boolean,
      default: true
    },
    bgClass: {
      type: String,
      default: 'bg-primary'
    },
    textClass: {
      type: String,
      default: 'text-light'
    }
  },
  data() {
    return {

    }
  },
  computed: {
    // 默认图片
    defaultImgSrc() {
      if (this.defaultImg) {
        return this.defaultImg
      }
      return require('@/assets/images/edit-image.png')
    },
    iconAlt() {
      if (!this.title) {
        return ''
      }
      return this.title.charAt(0).toUpperCase()
    },
    avatarClass() {
      const cls = []
      cls.push(`avatar-${this.size}`)
      return cls
    },
    avatarTitleClass() {
      const cls = ['avatar-title', this.bgClass, this.textClass]
      if (this.rounded) {
        cls.push('rounded')
      }
      if (this.roundedCircle) {
        cls.push('rounded-circle')
      }
      return cls
    }
  }
}
</script>
<template>
  <div>
    <div :class="avatarClass">
      <div :class="avatarTitleClass" style="overflow: hidden">
        <img v-if="imgSrc" :src="imgSrc" alt="" />
        <span v-else-if="iconAlt">{{ iconAlt }}</span>
        <img v-else :src="defaultImgSrc" alt="">
      </div>
    </div>
  </div>
</template>
